import React, { useContext } from 'react'
import { TranslateContext } from 'client/common/translator'
import { useSelector } from 'react-redux'
import { PlainText } from 'chemistry'

const LegalInfo = () => {
  const term = useSelector(store => store.data.term)
  const banner = useSelector(state => state.data.banner)
  const showLegalInfoListerSearchPages = useSelector(store => store.data?.flags?.showLegalInfoListerSearchPages)
  const t = useContext(TranslateContext)

  const legalTextForBanner = banner?.legalText?.defaultCopy?.json
  if (legalTextForBanner) {
    return (
      <div className='py1' style={{ gridArea: 'legal' }}>
        <PlainText json={legalTextForBanner} />
      </div>
    )
  }

  const key = 'lister.search.legal_info'
  const legalInfo = t(key) || 'XXX'

  const showInfo = showLegalInfoListerSearchPages && term && legalInfo !== key

  return (
    <div className='py1' style={{ gridArea: 'legal' }}>
      {showInfo ? legalInfo : ''}
    </div>
  )
}

export default React.memo(LegalInfo)
